export default import.meta.ROLLUP_FILE_URL_I_jcEmnb_lljugSlrGh9KA;